<template>
  <div class="footer-badges">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FooterBadgesList'
}
</script>

<style scoped>
.footer-badges {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .footer-badges {
    flex-direction: row;
    flex-wrap: wrap;
  }
}

@media (max-width: 576px) {
  .footer-badges {
    flex-direction: column;
  }
}
</style>

